import { useState } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { Box, Container } from '@mui/material'
import { darkTheme } from './theme/theme'
import { Sidebar } from './components/Sidebar'
import { TopBar } from './components/TopBar'
import Dashboard from './pages/Dashboard'
import Portfolios from './pages/Portfolios'
import Settings from './pages/Settings'
import Sectors from './pages/Sectors'
import MarketDrivers from './pages/MarketDrivers'
import Resources from './pages/Resources'
import ForecastRecord from './pages/ForecastRecord'
import { Accuracy } from './pages/Accuracy'

function App() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => setMobileOpen((prev) => !prev);

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <BrowserRouter>
        <Box sx={{ display: 'flex' }}>
          {/* Top AppBar */}
          <TopBar onMenuClick={handleDrawerToggle} />

          {/* Sidebar */}
          <Sidebar mobileOpen={mobileOpen} onClose={handleDrawerToggle} />

          {/* Main Content */}
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: 2,
              // Only offset width by drawer on desktop
              width: { md: `calc(100% - 240px)` },
              ml: { md: '240px' },
            }}
          >
            {/* Spacer for fixed AppBar */}
            <Box sx={(theme) => theme.mixins.toolbar} />
            <Container maxWidth="xl" sx={{ mt: 2 }}>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/market" element={<MarketDrivers />} />
                <Route path="/sectors" element={<Sectors />} />
                <Route path="/portfolios" element={<Portfolios />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/quota" element={<Navigate to="/resources" replace />} />
                <Route path="/forecast-record" element={<ForecastRecord />} />
                <Route path="/accuracy" element={<Accuracy />} />
                <Route path="/settings" element={<Settings />} />
              </Routes>
            </Container>
          </Box>
        </Box>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
